var bs_user_details = bs_user_details_obj = "", wpUserLoggedIn = false,
  updateHeaderCTA = vwoShowSignInState = false,
  csfSignedInStateExp = false,
  demoModalSignedInStateExp = false,
  bstackCheckAcceptCookie = false,
  freeTrialUserFlag = true,
  freeTrialListParams = ['Trial', 'Extended Trial', 'Freemium'];
  
function getCookieVal(name, stage_bool) {
  var nameEQ = (stage_bool ? (stage_env_cookie_prefix + name).trim() : name.trim()) + "=", ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') { c = c.substring(1, c.length); }
    if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length, c.length); }
  }
  return null;
}

function setCookieVal(name, value, days, stage_bool) {
  var d = new Date(), 
  domain = window.location.hostname.substr(window.location.hostname.indexOf('.'));
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = (stage_bool ? (stage_env_cookie_prefix + name).trim() : name.trim()) + "=" + value + ";path=/;domain=" + domain + ";expires=" + d.toGMTString();
}

if (getCookieVal("bs_logging_id", true)) {
  wpUserLoggedIn = true;
  try {
    if (getCookieVal("bs_user_details", true)) {
      bs_user_details = getCookieVal("bs_user_details", true);
      var u_detail = JSON.parse(bs_user_details);
      if (u_detail && typeof u_detail === "object") {
        if (u_detail.plan_details !== undefined) {
          bs_user_details_obj = u_detail;
        }
      }
    }
  } 
  catch (error) {}
}

//FT full roll code
if (bs_user_details_obj) {
  Object.keys(bs_user_details_obj.plan_details).forEach(function (key) {
    if (bs_user_details_obj.plan_details.hasOwnProperty(key)) {
      if (freeTrialListParams.indexOf(bs_user_details_obj.plan_details[key]['type']) === -1) {
        freeTrialUserFlag = false;
        return;
      }
    }
  });
} else {
  freeTrialUserFlag = false;
}

if (freeTrialUserFlag && getCookieVal('bs_logging_id', true) !== null) {
  vwoShowSignInState = true;
}

// check local storgae expiry time for log out state chat
try {
  var freshChatLocalVal = localStorage.getItem('set_freshchat_state');
  if (freshChatLocalVal) {
    if (new Date().getTime() > JSON.parse(freshChatLocalVal)) {
      localStorage.removeItem('set_freshchat_state');
    }
  }

  var cookieNotificationVal = getCookieVal("UserOptCookie", true);
  if (cookieNotificationVal) {
    bstackCheckAcceptCookie = true;
  }
}
catch(e) { }

//sync cookie vwo and rails ab experiment
var header_3_1_experiment_v3 = getCookieVal("header_3_1_experiment_v3", true),
header_3_1_exp_vwo = getCookieVal("_vis_opt_exp_713_combi", false);
if (header_3_1_experiment_v3 && header_3_1_experiment_v3 != header_3_1_exp_vwo) {
  setCookieVal('_vis_opt_exp_713_combi', header_3_1_experiment_v3, 30, false);
} else if (header_3_1_exp_vwo && header_3_1_experiment_v3 != header_3_1_exp_vwo) {
  setCookieVal('header_3_1_experiment_v3', header_3_1_exp_vwo, 30, true);
}

//Trust arc 
if (enableTrustArcCCM && !wpUserLoggedIn) {
  (function(w, d, s) {
    // Check if an element with ID 'truste-consent-js' already exists in <head>
    if (d.getElementById('truste-consent-js')) return;

    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s);
        
    j.async = true;
    j.id = 'truste-consent-js'; // Set the ID here
    j.src = 'https://consent.trustarc.com/v2/notice/gufq6p';
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script');
}

var cookieValue = enableTrustArcCCM ? 'true' : 'false';

//Add common cookie for rails and wp to track user consent on trustarc
setCookieVal(stage_env_cookie_prefix + 'is_trustarc_enabled', cookieValue, 30, true);